import { ClosedState, CronoCallState } from './hooks/cronoCallReducer';
import { Settings } from './Settings';
import { CalleeInfo } from './CalleeInfo';
import { CallControls } from './CallControls';
import { DialpadGrid } from './DialpadGrid';
import { HangupButton } from './HangupButton';

export type CronoCallUIProps = {
  callStatusText: string;
  callState: Exclude<CronoCallState, ClosedState>;
  hangup: () => void;
  mute: (shouldMute: boolean) => void;
  openDialpad: (shouldOpen: boolean) => void;
  playDTMF: (digits: string) => void;
  startRecording: () => void;
  openSettings: (shouldOpen: boolean) => void;
  changeMicrophone: (deviceId: string) => void;
  changeSpeaker: (deviceId: string) => void;
};

export const CronoCallUI = ({
  callStatusText,
  callState,
  hangup,
  mute,
  openDialpad,
  playDTMF,
  startRecording,
  openSettings,
  changeMicrophone,
  changeSpeaker,
}: CronoCallUIProps) => {
  const isOpen = callState.status === 'open';
  const isMuted = 'isMuted' in callState && callState.isMuted;
  const isDialpadOpen = 'isDialpadOpen' in callState && callState.isDialpadOpen;
  const isRecording = 'isRecording' in callState && callState.isRecording;

  return (
    <div className="flex flex-col items-center justify-center flex-1">
      <CalleeInfo callee={callState.callee} callStatusText={callStatusText} />

      <CallControls
        isOpen={isOpen}
        isMuted={isMuted}
        isRecording={isRecording}
        isDialpadOpen={isDialpadOpen}
        areSettingsOpen={callState.areSettingsOpen}
        mute={mute}
        startRecording={startRecording}
        openDialpad={openDialpad}
        openSettings={openSettings}
      />

      {isDialpadOpen && <DialpadGrid onDigitClick={playDTMF} />}

      {callState.areSettingsOpen && (
        <Settings
          callState={callState}
          close={() => openSettings(false)}
          changeMicrophone={changeMicrophone}
          changeSpeaker={changeSpeaker}
        />
      )}

      <HangupButton onClick={hangup} />
    </div>
  );
};
